/* ============================================================
   BloomUp: product-card quick add-to-cart
   Pairs with snippets/bloomup-card-atc.liquid + bloomup-card-atc.css.

   Trigger label logic lives in card-product1.liquid: "Select Size"
   when the product needs a size choice, "Add to Cart" when it has
   only one variant. This file mirrors that at runtime by checking
   whether the card's panel actually contains size pills, so a
   single-variant product never opens a panel/sheet that would just
   show a second "Add to Cart" button — it adds directly on tap, with
   the "Adding…" / "Added ✓" feedback shown on the trigger itself
   (not a hidden clone), via the shared addToCart() helper below.

   Desktop (>=1150px, hover devices): hover panel on the card image →
   pick size → ADD TO CART.
   Tablet (768–1149px): tapping "Select Size" toggles the SAME in-card
   panel open (no hover needed) instead of opening a separate popup —
   tap again, tap outside, or tap another card's trigger to close it.
   Phone (<768px), or any touch device outside the tablet band: the
   trigger opens the full bottom sheet (large image carousel, product
   name, price, size pills, ADD TO CART).

   Body scroll is locked with the position:fixed technique (reliable on
   iOS Safari, where overflow:hidden alone lets the page scroll/jitter
   behind the sheet); scroll position is restored INSTANTLY on close
   (scroll-behavior forced to auto for the restore, so the page never
   visibly animates back to position). Scroll is NOT locked for the
   tablet in-card panel since it isn't a full-screen overlay.
   ============================================================ */
(function () {
  "use strict";

  /* ---------------- drawer helpers ---------------- */
  function openDrawer() {
    var trigger = document.querySelector('a[aria-controls="CartDrawer"]');
    if (trigger) { trigger.click(); return; }
    var dlg = document.querySelector("dialog#CartDrawer");
    if (dlg && typeof dlg.showModal === "function" && !dlg.open) {
      try { dlg.showModal(); } catch (e) {}
    }
  }
  function syncCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll("hdt-cart-count").forEach(function (el) {
          el.textContent = c.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---------------- shared add-to-cart: POST + visible button feedback ----------------
     btn is whatever the shopper actually tapped (the trigger for a
     direct single-variant add, or the "Add to Cart" button inside an
     open panel/sheet) — feedback always shows on that real element,
     never on a hidden clone. opts.onSuccess runs after a successful
     add, before the button label resets. */
  function addToCart(id, btn, opts) {
    opts = opts || {};
    if (!id || !btn || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding\u2026";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        btn.textContent = "Added \u2713";
        if (opts.onSuccess) opts.onSuccess();
        /* open right away — don't wait for the section fetch */
        openDrawer();
        syncCount();
        if (window.BUCart && window.BUCart.rerender) {
          if (window.BUCart.setLoading) window.BUCart.setLoading(true);
          window.BUCart.rerender(function () {
            if (window.BUCart.setLoading) window.BUCart.setLoading(false);
          });
        }
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = label;
        }, 1200);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = "Try again";
        setTimeout(function () { btn.textContent = label; }, 2000);
      });
  }

  /* ---------------- tablet band check (matches the CSS breakpoint) ---------------- */
  var tabletMql = window.matchMedia("(min-width:768px) and (max-width:1149.98px)");
  function isTabletWidth() {
    return tabletMql.matches;
  }

  /* ---------------- trigger label ----------------
     Mobile always shows "Add to Cart" (tapping it opens the full-screen
     sheet, where the real size pick happens). Tablet shows "Select
     Size" instead, but ONLY for products that need a size choice,
     since there the picker opens right next to this same button
     rather than as a full-screen transition — showing "Add to Cart"
     twice on one screen there would read as two separate buttons. */
  function relabelTrigger(trig) {
    if (!trig || trig.disabled) return;
    var media = trig.closest(".hdt-card-product__media") || trig.closest(".hdt-card-product");
    var src = media ? media.querySelector("[data-bu-catc]") : null;
    var hasSizes = !!(src && src.querySelector(".bu-catc-sizes"));
    var label = isTabletWidth() && hasSizes ? "Select Size" : "Add to Cart";
    trig.textContent = label;
    trig.setAttribute("aria-label", label);
  }
  function relabelAllTriggers() {
    document.querySelectorAll(".bu-catc-m-trigger").forEach(relabelTrigger);
  }
  relabelAllTriggers();
  if (tabletMql.addEventListener) {
    tabletMql.addEventListener("change", relabelAllTriggers);
  } else if (tabletMql.addListener) {
    tabletMql.addListener(relabelAllTriggers); /* Safari <14 fallback */
  }
  /* relabel triggers added later (load more / infinite scroll / re-renders) */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches(".bu-catc-m-trigger")) relabelTrigger(n);
        if (n.querySelectorAll) {
          n.querySelectorAll(".bu-catc-m-trigger").forEach(relabelTrigger);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------------- tablet in-card panel (tap-toggled) ---------------- */
  function closeTapPanels(except) {
    document.querySelectorAll(".bu-catc.bu-tap-open").forEach(function (p) {
      if (p !== except) p.classList.remove("bu-tap-open");
    });
  }
  function toggleTapPanel(panel) {
    var wasOpen = panel.classList.contains("bu-tap-open");
    closeTapPanels(panel);
    panel.classList.toggle("bu-tap-open", !wasOpen);
  }

  /* ---------------- body scroll lock (iOS-safe, instant restore) ---------------- */
  var savedScrollY = 0;
  var bodyLocked = false;
  function lockBody() {
    if (bodyLocked) return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = "fixed";
    b.style.top = -savedScrollY + "px";
    b.style.left = "0";
    b.style.right = "0";
    b.style.width = "100%";
    b.classList.add("bu-sheet-lock");
    bodyLocked = true;
  }
  function unlockBody() {
    if (!bodyLocked) return;
    var b = document.body;
    var html = document.documentElement;
    b.classList.remove("bu-sheet-lock");
    b.style.position = "";
    b.style.top = "";
    b.style.left = "";
    b.style.right = "";
    b.style.width = "";
    bodyLocked = false;
    /* force an instant (non-animated) jump back to the saved position,
       even when the theme sets scroll-behavior:smooth on html/body */
    var prevHtml = html.style.scrollBehavior;
    var prevBody = b.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    b.style.scrollBehavior = "auto";
    try {
      window.scrollTo({ top: savedScrollY, left: 0, behavior: "instant" });
    } catch (e) {
      window.scrollTo(0, savedScrollY);
    }
    /* restore original scroll-behavior on the next frame */
    requestAnimationFrame(function () {
      html.style.scrollBehavior = prevHtml;
      b.style.scrollBehavior = prevBody;
    });
  }

  /* ---------------- mobile bottom sheet ---------------- */
  function sheetEl() {
    var el = document.querySelector(".bu-catc-sheet");
    if (el) return el;
    el = document.createElement("div");
    el.className = "bu-catc-sheet";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-label", "Select size");
    el.innerHTML =
      '<div class="bu-catc-sheet-backdrop"></div>' +
      '<div class="bu-catc-sheet-panel" data-bu-catc>' +
      '<button type="button" class="bu-catc-sheet-close" aria-label="Close">&times;</button>' +
      '<div class="bu-catc-sheet-handle"></div>' +
      '<div class="bu-catc-sheet-body"></div>' +
      "</div>";
    document.body.appendChild(el);
    return el;
  }
  function openSheet(sourcePanel) {
    var sheet = sheetEl();
    var body = sheet.querySelector(".bu-catc-sheet-body");
    var panelBox = sheet.querySelector(".bu-catc-sheet-panel");
    var titleText = sourcePanel.getAttribute("data-bu-title") || "";
    body.innerHTML = "";
    if (panelBox) panelBox.scrollTop = 0;

    /* large image carousel */
    var imgsAttr = sourcePanel.getAttribute("data-bu-images") || "";
    var urls = imgsAttr.split("|").filter(function (u) { return u && u.length > 4; });
    if (urls.length) {
      var strip = document.createElement("div");
      strip.className = "bu-catc-sheet-imgs";
      urls.forEach(function (u, i) {
        var im = document.createElement("img");
        im.src = u;
        im.alt = titleText;
        if (i > 0) im.loading = "lazy";
        im.draggable = false;
        strip.appendChild(im);
      });
      body.appendChild(strip);
    }

    /* product name below image */
    var titleEl = document.createElement("div");
    titleEl.className = "bu-catc-sheet-title";
    titleEl.textContent = titleText;
    body.appendChild(titleEl);

    /* price row */
    var price = sourcePanel.getAttribute("data-bu-price");
    if (price) {
      var row = document.createElement("div");
      row.className = "bu-catc-sheet-price";
      var cur = document.createElement("span");
      cur.className = "bu-cur";
      cur.textContent = price;
      row.appendChild(cur);
      var cmpV = sourcePanel.getAttribute("data-bu-compare");
      if (cmpV) {
        var cmp = document.createElement("span");
        cmp.className = "bu-cmp";
        cmp.textContent = cmpV;
        row.appendChild(cmp);
        var d = sourcePanel.getAttribute("data-bu-discount");
        if (d) {
          var off = document.createElement("span");
          off.className = "bu-off";
          off.textContent = d + "% off";
          row.appendChild(off);
        }
      }
      body.appendChild(row);
    }

    /* size pills + add button (cloned from the card's hidden panel) */
    var sizes = sourcePanel.querySelector(".bu-catc-sizes");
    if (sizes) body.appendChild(sizes.cloneNode(true));
    var add = sourcePanel.querySelector(".bu-catc-add");
    if (add) {
      var addClone = add.cloneNode(true);
      addClone.disabled = false;
      addClone.textContent = "Add to Cart";
      body.appendChild(addClone);
    }
    lockBody();
    requestAnimationFrame(function () { sheet.classList.add("bu-open"); });
  }
  function closeSheet() {
    var sheet = document.querySelector(".bu-catc-sheet");
    if (sheet) sheet.classList.remove("bu-open");
    unlockBody();
  }

  /* ---------------- clicks ---------------- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* tablet: tapping outside an open in-card panel (and outside any
       trigger button, so opening a different card's panel is handled
       by the trigger branch below, not double-handled here) closes it */
    if (!t.closest(".bu-catc") && !t.closest(".bu-catc-m-trigger")) {
      closeTapPanels();
    }

    /* trigger button below the price (mobile + tablet) */
    var trig = t.closest(".bu-catc-m-trigger");
    if (trig) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (trig.disabled) return;
      var media = trig.closest(".hdt-card-product__media") || trig.closest(".hdt-card-product");
      var src = media ? media.querySelector("[data-bu-catc]") : null;
      if (!src) return;

      var hasSizes = !!src.querySelector(".bu-catc-sizes");
      if (!hasSizes) {
        /* single variant — the trigger already reads "Add to Cart";
           add directly, showing Adding…/Added on the TRIGGER itself
           (not a hidden clone) instead of opening a panel/sheet that
           would just show a second "Add to Cart" button */
        var directAdd = src.querySelector(".bu-catc-add");
        var vid = directAdd ? parseInt(directAdd.getAttribute("data-default-variant"), 10) : null;
        addToCart(vid, trig);
        return;
      }

      if (isTabletWidth()) {
        toggleTapPanel(src);
      } else {
        openSheet(src);
      }
      return;
    }

    /* sheet close: X button or backdrop tap */
    if (t.closest(".bu-catc-sheet-close")) { closeSheet(); return; }
    var sh = t.closest(".bu-catc-sheet");
    if (sh && !t.closest(".bu-catc-sheet-panel")) { closeSheet(); return; }

    /* size pill (panel or sheet) */
    var size = t.closest(".bu-catc-size");
    if (size) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var panel = size.closest("[data-bu-catc]");
      if (panel) {
        panel.querySelectorAll(".bu-catc-size.is-selected").forEach(function (el) {
          el.classList.remove("is-selected");
        });
        size.classList.add("is-selected");
      }
      return;
    }

    /* add to cart (panel or sheet) */
    var add = t.closest(".bu-catc-add");
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (add.disabled) return;
      var panel2 = add.closest("[data-bu-catc]");
      var sel = panel2 ? panel2.querySelector(".bu-catc-size.is-selected") : null;
      var id = sel
        ? parseInt(sel.getAttribute("data-variant-id"), 10)
        : parseInt(add.getAttribute("data-default-variant"), 10);
      if (!id) return;
      var inSheet = !!add.closest(".bu-catc-sheet");
      addToCart(id, add, {
        onSuccess: function () { if (inSheet) closeSheet(); }
      });
      return;
    }
  }, true);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" || e.key === "Esc") {
      var open = document.querySelector(".bu-catc-sheet.bu-open");
      if (open) { closeSheet(); return; }
      closeTapPanels();
    }
  });
})();
